<template>
  <div class="syj_popsuccess" v-show="isShow">
    <div class="popup-content">
      <div class="syj_border-linear"></div>
      <div class="bgwhite cursorPointer">
        <div class="common-pop">
          <div>{{ message }}</div>
          <img
              @click="ispopClose"
              src="../../../assets/images/close.png"
              class="close"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      message: "",
      isShow: false,
    };
  },
  mounted() {
    window.Toast = this.show;
  },
  methods: {
    show(msg, delay = false) {
      this.message = msg;
      this.isShow = true;
      if (delay) {
        setTimeout(() => {
          this.message = "";
          this.isShow = false;
        }, delay);
      }
    },
    ispopClose() {
      this.isShow = false;
    }
  },
};
</script>
<style scoped lang="less">
.close {
  position: unset;
}
.syj_popsuccess {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  position: relative;
  max-width: 550px;
  img {
    flex-shrink: 0;
    margin-left: 10px;
  }
}
</style>
<style lang="less">
.syj_popsuccess {
  .bgwhite {
    background: #ffff;
    margin: 5px;
  }
  
  .common-pop {
    display: flex;
    padding: 10px;
    
    img {
      width: 16px;
      height: 16px;
      margin-top: 3px;
    }
  }
  
  min-width: 450px;
  box-shadow: 1px 2px 13px 5px #b5b5b5;
  border-radius: 4px;
  overflow: hidden;
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
}

@media (max-width: 480px) {
  .syj_popsuccess {
    min-width: 200px;
    width: 90%;
  }
}
</style>
